export function phoneinput(elem) {
  elem.intlTelInput({
    utilsScript: '../../build/js/utils.js',
    initialCountry: elem.data('country-code'),
    nationalMode: false,
    preventInvalidDialCodes: true,
    formatOnDisplay: false
  });


  elem.each(function () {
    if (this) {
      window.Parsley.addValidator('phoneValidate', function (value) {
        var obj = $('<input/>');
        obj.intlTelInput();
        obj.val(value);
        if (!value || value.length === 0) { return; }
        return obj.intlTelInput('isValidNumber');
      }, 32)
        .addMessage('en', 'phoneValidate', I18n.t('js.valid_phone_number')); // eslint-disable-line no-undef
    }
  });
}

window.phoneinput = phoneinput;

$(document).ready( function () {
  phoneinput($('.phone-input'));
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/intl-tel-input.js